module.exports = __webpack_public_path__ + "static/media/banner-img.ff5cd367.svg";